<script lang="ts" setup></script>

<template>
  <div
    class="flex items-center gap-3 cursor-pointer text-gray-700 dark:text-slate-300"
    @click="openLink('https://www.nocodb.com')"
  >
    <GeneralIcon icon="nocodb1" class="w-7 h-7 -my-0.5" />

    <div class="text-sm">NocoDB Forms</div>
  </div>
</template>
